<template>
  <div id="form_anchor"></div>
<!--  <div class="hero-w">-->
<!--    <div class="hero wf-section">-->
<!--      <div class="container">-->
<!--        <div class="hh-co">-->
<!--          <h1 class="hh1 mb">Oslávte Vašu výhru s naším golfovým poistením</h1>-->
<!--          <div class="sp"></div>-->
<!--          <h2 class="hh2">Najoblúbeneišie golfové poistenie už od roku 2002 prináša istotu počas hry na Slovensku aj na cestách za golfom po celom svete.</h2>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="hero-ac">-->
<!--        <a href="/conditions" class="btna w-inline-block">-->
<!--          <div class="mr">Mám záujem</div>-->
<!--          <div class="ico ico-r"></div>-->
<!--        </a>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
  <div v-show="page === 'home'" class="page-1">
    <div class="col_hr"><div class="col_hero_w"><div class="container"><div class="hh-co"><h1 class="hh1 mb-x">Cestujte bezpečne <br>do celého sveta <br>s naším poistením</h1><a href="#calc-anchor" class="btn w-button">Objednať poistenie </a></div></div></div></div>

    <div class="sec">
      <div class="container content">
        <div class="cf">

        <div>
        <h2 id="calc-anchor" class="h2 mb">Aký je účel vašej cesty ?</h2>
          <small>Vyberte jednu alebo viac možností</small>
        </div>
        <div class="slc_w slc_wnw mb-xl">
          <TravelReasonRadio v-model="formData.travel_reason" />
        </div>
          <div class="col-34">
            <div class="step" v-if="formData.travel_reason?.length">
              <div>
                <h2 class="h2 mb">Kam cestujete ?</h2>
                <small>Vyberte jednu z možností</small>
              </div>
              <RegionalCoverageRadio v-model="formData.regional_coverage" :travelReason="formData.travel_reason"/>
            </div>
            <div class="step" v-if="formData.regional_coverage && formData.regional_coverage.length">
              <h2 class="h2 mb">Ako cestujete ?</h2>
              <small>Vyberte jednu alebo viac možností</small>
              <TravelingByRadio v-model="formData.traveling_by"/>
            </div>
            <div class="step" v-if="formData.traveling_by">
              <h2 class="h2 mb">Chcete pripoistenie zrušenia cesty ?</h2>
              <small>Vyberte jednu z možností</small>

              <StornoRadio v-model="formData.storno_type"/>
            </div>
            <div class="step" v-if="formData.storno_type && formData.traveling_by">
              <div class="c mb-x"><h2 class="h3 mb">Kedy cestujete ?</h2>
                <small>Zvoľte dátum začiatku a konca vašej cesty.</small>
                <div class="cohw">
                  <div class="date_w">
                    <div class="date">
                      <div class="mr">
                        <div class="coh cohc mb">
                          <!--                    <div class="check bg1 mr">-->
                          <!--                      <div></div>-->
                          <!--                    </div>-->
                          <div>Začiatok&nbsp;cesty&nbsp;-&nbsp;od</div>
                        </div>
                        <div class="form-block w-form">
                          <DatePickerWrap
                              class-name="insurance_from"
                                          @input="formData.insurance_from = $event"
                                          :value="formData.insurance_from"
                                          :min-date="Date()"
                          />
                          <!--                    <DatePickerWrap-->
                          <!--                        @input="formData.insurance_from = $event"-->

                          <!--                    />-->
                          <!--                    &lt;!&ndash;                        @minDate="insuranceStartMin"&ndash;&gt;-->
                          <!--                    <DatePickerWrap v-model="formData.insurance_from" />-->
<!--                          <input class="w-input w-in cb_trv in in_trv " type="date" v-model="formData.insurance_from">-->
                          <div class="invalid-feedback" v-if="v$.formData.insurance_from.dateBeforeOrEqual.$invalid">
                            Dátum začiatku musí byť skôr alebo rovný ako dátum konca
                          </div>
                          <div class="invalid-feedback" v-if="v$.formData.insurance_from.notBeforeToday.$invalid">Dátum
                            začiatku musí byť najskôr dnešný.
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="date_sep"></div>
                    <div class="date">
                      <div class="mr">
                        <div class="coh cohc mb">
                          <!--                    <div class="check bg1 mr">-->
                          <!--                      <div></div>-->
                          <!--                    </div>-->
                          <div>Koniec cesty - do</div>
                        </div>
                        <div class="form-block w-form">
<!--                          <input class="w-input w-in cb_trv in in_trv " type="date" v-model="formData.insurance_to"-->
<!--                                 :disabled="product === 'short_eu_day'">-->
                          <DatePickerWrap :min-date="minDateTo"
                                          class-name="insurance_to"
                              @input="formData.insurance_to = $event"
                                          :value="formData.insurance_to"
                                          :disabled="product === 'short_eu_day'" />
                          <div class="invalid-feedback" v-if="v$.formData.insurance_to.dateRange.$invalid">Nie je možné
                            dojednať cez web, prosím napíšte na <a href="mailto:info@travelinsurance.sk">info@travelinsurance.sk</a>
                            poistenie podľa vašich požiadaviek Vám dojednáme individuálne.
                          </div>
                          <div class="invalid-feedback" v-if="v$.formData.insurance_to.euDay.$invalid">Poistenie
                            koncertu pre územný rozsah EU trvá 24 hodín a dátum odchodu a príchodu musia byť po sebe
                            idúce dni
                          </div>
                          <div class="note" v-if="product === 'short_eu_day'">Poistenie cesty na koncert - máte za cenu
                            1 dňa krytý aj nasledujúci deň pre prípad ak by návrat bol po polnoci.
                          </div>

                          <!--                    <DatePickerWrap @input="formData.insurance_to"-->
                          <!--                      @minDate="insuranceEndMin"-->
                          <!--                      @maxDate="insuranceEndMin"-->
                          <!--                    />-->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="step" v-if="formData.insurance_from && formData.insurance_to">
              <div class="c mb-x"><h2 class="h3 mb">Koľko osôb poisťujete ?</h2>
                <small>Naraz je možné poistiť najviac <strong>4 osoby.</strong></small>
                <div class="cohw">
                  <div class="date_w">
                    <label style="font-weight: lighter">
                      <div class="coh cohc mb">
                        <!--                    <div class="check bg1 mr">-->
                        <!--                      <div></div>-->
                        <!--                    </div>-->
                        <div class="w">Počet poistených osôb</div>
                      </div>
                      <input name="travellers_count_input" class="w-input w-in cb_trv in in_trv" type="number" step="1"
                             v-model="travellers_count_input" min="1" max="4"/>
                      <div class="invalid-feedback" v-if="v$.travellers_count_input.range.$invalid">
                        Vyšší počet cestujúcich ako 4 prosím zadajte na viac prihlášok,
                        prípadne nás kontaktujte na <a href="mailto:info@travelinsurance.sk">info@travelinsurance.sk</a>
                      </div>
                      <div class="invalid-feedback" v-if="v$.travellers_count_input.required.$invalid">
                        Pole je povinné
                      </div>

                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="c mb-x" v-if="formData.storno_type && formData.traveling_by?.length && formData.insurance_from && formData.insurance_to  && formData.storno_type !== 'SEPARATE'"><h2 class="h3 mb">Poistenie pre seniora 70+ ?</h2>
              <AgeSelectRadio v-model="formData.age_above_70" :travel-reason="formData.travel_reason" />
              <div class="cohw custom-radio">
<!--                <label :class="{chew: true, 'chew-active': !formData.age_above_70}">-->
<!--                  <input type="radio" v-model="formData.age_above_70" :value="false"/>-->
<!--                  <div class="mr">Vek do 70 rokov</div>-->
<!--                  <div class="check">-->
<!--                    <div v-if="!formData.age_above_70"></div>-->
<!--                  </div>-->
<!--                </label>-->
<!--                <label :class="{chew: true, 'chew-active': formData.age_above_70}">-->
<!--                  <input type="radio" v-model="formData.age_above_70" :value="true"/>-->
<!--                  <div class="mr">Vek nad 70 rokov</div>-->
<!--                  <div class="check">-->
<!--                    <div v-if="formData.age_above_70"></div>-->
<!--                  </div>-->
<!--                </label>-->
<!--                <div class="vek_info">-->
<!--                  <div>Pre dojednanie poistenia osôb nad 70 rokov si prosím zadajte samostatnú poistku len pre tieto-->
<!--                    osoby.-->
<!--                  </div>-->
<!--                </div>-->
              </div>
            </div>
            <div v-show="product && !(v$.formData.insurance_from.$invalid || v$.formData.insurance_to.$invalid)" id="ceny" class="sec">
              <div class="">
                <div class="">
                  <div class="c mb-x"><h2 class="h1">Rozsah poistenia</h2>
                    <div class="sp"></div>
                  </div>
                  <CoverageTable v-if="product && product !== 'storno'" :product="product" :showPrice="product !== 'short_eu_world'" :price="formatPrice(basePrice)" />

                  <div v-show="product && product === 'short_eu_world'">
                    <AdditionalInsurances
                        :form-data="formData" v-model="formData.additional_insurances"
                        :days-count="daysCount" :productPrice="basePrice"
                        :product="product"
                        @updateSelectedPrice="updatePriceAfterAdditionals($event)"
                    />
                  </div>





                  <div class="c mb-xxl" v-if="formData.storno_type && formData.storno_type !== 'NONE'" >
                    <div class="rop rop-x">
                      <div class="rop-t"><h2 class="h3 fc-2"><strong>STORNO – zrušenie cesty pred odchodom
                        <PdfInfoTooltip :link="'/attachments/storno_sk/' + (formData.storno_type === 'ADDON' ? 'storno_pripoistenie_KCP.pdf' : 'storno_samost_SCP.pdf' )" />
                        <span v-if="formData.storno_type === 'SEPARATE'">,  skrátenie už začatej cesty </span>
                      </strong></h2></div>
                    </div>
                    <div class="rop">
                      <div class="rop-t">
                        <div>
                          <div>Celková cena cesty pre všetky osoby – poistná suma</div>
                        </div>
                      </div>
                      <div class="rop-c">
                        <div class="rop-b rop-bf">
                          <div class="form-block w-form">
                            <input
                                class="in w-input" maxlength="256" name="trip_cancellation_coverage" data-name="Name 2" placeholder="Suma" v-model="formData.trip_cancellation_coverage"
                                type="text" id="name-2">

                            <div class="invalid-feedback m-5" v-if="v$.formData.trip_cancellation_coverage.required.$invalid && v$.formData.trip_cancellation_coverage.$dirty">
                              Pole je vyžadované
                            </div>
                            <div class="invalid-feedback m-5" v-if="v$.formData.trip_cancellation_coverage.limit.$invalid && v$.formData.trip_cancellation_coverage.$dirty">
                              Maximálne 10 000 EUR na osobu
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="rop">
                      <div class="rop-t">
                        <div>
                          <div>Dátum zakúpenia cesty / služby</div>
                        </div>
                      </div>
                      <div class="rop-c">
                        <div class="rop-b rop-bf">
                          <div class="form-block w-form">
<!--                            <input-->
<!--                                class="in w-input" maxlength="256" name="name-2" data-name="Name 2" placeholder="Dátum"-->
<!--                                type="date" id="name-2" v-model="formData.trip_cancellation_reference_date">-->
                            <DatePickerWrap
                                :key="formData.trip_cancellation_reference_date"
                                @input="formData.trip_cancellation_reference_date = $event"
                                :value="formData.trip_cancellation_reference_date"
                                :max-date="new Date()"
                                class-name="trip-cancellation-reference-date"
                              />

                          </div>

                          <small>Poistenie storna je možné dojednať v deň zakúpenia cesty / služby,
                            alebo viac ako 30 dní pred začiatkom cesty.</small>
                          <div class="invalid-feedback m-5" v-if="v$.formData.trip_cancellation_reference_date.required.$invalid && v$.formData.trip_cancellation_reference_date.$dirty">
                            Pole je vyžadované
                          </div>
                          <div class="invalid-feedback m-5" v-if="v$.formData.trip_cancellation_reference_date.rules30.$invalid && v$.formData.trip_cancellation_reference_date.$dirty">
                            nedá sa dojednať ak je dátum dojednania menej ako 30 dní pred začiatkom cesty
                            OKREM prípadu ak je dátum dojednania ZHODNÝ s dátumom nákupu letenky
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--            <div class="rop" v-if="formData.storno_type && formData.storno_type !== 'SEPARATE'">-->
                    <!--              <div class="rop-t">-->
                    <!--                <div>-->
                    <!--                  <div>Storno cena</div>-->
                    <!--                </div>-->
                    <!--              </div>-->
                    <!--              <div class="rop-c">-->
                    <!--                <div class="rop-b rop-bf">-->
                    <!--                  {{ this.formatPrice(tripCancellationPrice) }}-->
                    <!--                </div>-->
                    <!--              </div>-->
                    <!--            </div>-->
                    <div class="rop rop-x">
                      <div class="rop-t">
                        <div><h3 class="h4">Cena za storno</h3></div>
                      </div>
                      <div class="rop-c">
                        <div class="rop-b rop-bf">
                          <div class="h4">{{ formatPrice(tripCancellationPrice) }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="c mb-xxl" v-if="formData.storno_type !== 'NONE' || formData.product !== 'short_eu_world'" >
                    <div class="rop rop-x">
                      <div class="rop-t">
                        <div><h3 class="h3">Celková cena</h3></div>
                      </div>
                      <div class="rop-c">
                        <div class="rop-b rop-bf">
                          <div class="h3">{{ formatPrice(totalPrice) }}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="rop_btn_w"><a href="#form_anchor" @click="goToForm" class="btn btn_xl w-button">Kúpiť
                    poistenie </a></div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-14 hide_t">
            <div class="stck">
              <InfoBox :form-data="formData" :days-count="daysCount" />
            </div>
          </div>
    </div>



    </div>

    </div>


<!--  <div class="sec">-->
<!--    <div class="container">-->
<!--      <div class="trv_prc bg1">-->
<!--        <div class="col-12"><h4 class="h3 fc-3">Celková cena poistenia</h4><h4 class="h2">{{ price}} €</h4>-->
<!--          <div class="col-23">Vrátane dane z neživotného poistenia vo výške 8%</div>-->
<!--        </div>-->
<!--        <div class="col-12 ccc"><a href="#form_anchor" @click="goToForm" class="btn btn_trv w-inline-block">-->
<!--          <div class="mr">Pokračovať</div>-->
<!--          <div class="ico ico-r"></div>-->
<!--        </a></div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->






  <div id="faq" class="sec">
    <div class="container">
      <div class="col-13">
        <div class="stck">
          <h2 class="h2">Otázky a odpovede</h2>
          <div class="sp"></div>
        </div>
      </div>
      <div class="col-23">
        <FAQPart />

      </div>
    </div>
  </div>
  </div>
  <ApplicationComponent v-show="page === 'form'" @back="goToHome" :price="totalPrice" :configuration="formData" :product="product" />




</template>

<script>
// @ is an alias to /src

import FAQPart from "@/components/accordion/FAQPart";
import ApplicationComponent from "@/components/ApplicationComponent.vue";
import TravelReasonRadio from "@/components/parts/trip/TravelReasonRadio.vue";
import RegionalCoverageRadio from "@/components/parts/trip/RegionalCoverageRadio.vue";
import TravelingByRadio from "@/components/parts/trip/TravelingByRadio.vue";
import StornoRadio from "@/components/parts/trip/StornoRadio.vue";
import CoverageTable from "@/components/parts/trip/CoverageTable.vue";
import AdditionalInsurances from "@/components/parts/trip/AdditionalInsurances.vue";
import useValidate from "@vuelidate/core";
import InfoBox from "@/components/parts/trip/infoBox.vue";
import DatePickerWrap from "@/components/parts/DatePickerWrap.vue";
import PdfInfoTooltip from "@/components/PdfInfoTooltip.vue";
import AgeSelectRadio from "@/components/parts/trip/AgeSelectRadio.vue";
import useInsuranceFormMixin from "@/components/parts/trip/useInsuranceFormMixin";

export default {
  name: 'HomeView',
  mixins: [useInsuranceFormMixin],
  setup () {
    return {
      v$: useValidate({ $autoDirty: true })
    }
  },
  components: {
    AgeSelectRadio,
    PdfInfoTooltip,
    DatePickerWrap,
    InfoBox,
    AdditionalInsurances,
    CoverageTable,
    StornoRadio,
    TravelingByRadio,
    RegionalCoverageRadio,
    TravelReasonRadio,
    ApplicationComponent,
    FAQPart,
  }
}
</script>
<style>
img{
  max-width: 100%;

}
strong{
  color: var(--main-color);
}


/*.hero.has-content:after {*/
/*  content: '';*/
/*  width: 100%;*/
/*  height: 100%;*/
/*  display: block;*/
/*  position: absolute;*/
/*  opacity: 1;*/
/*  z-index: 1;*/
/*  background-image: linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0.1) 50%, rgba(0,0,0,0.0) 70%);*/
/*}*/
/*.hero .container{*/
/*  position: relative;*/
/*  z-index: 2;*/
/*}*/
/*.hero h2{*/
/*  font-size: 2.5rem;*/
/*  margin-top: 320px;*/
/*  padding-bottom: 15px;*/
/*  color: white;*/
/*}*/

.custom-radio label input[type=radio], .custom-radio label input[type=checkbox]{
  visibility: hidden;
  width: 1px;
  height: 1px;
}
.custom-radio label{
  cursor: pointer;
}

.custom-radio label:has(input:not(:checked)) .check-char{
  opacity: 0;
}


.covering{
  font-size: 0.9em;

}
.covering td{
  padding: 5px;
}
.table td:nth-child(2){
  text-align: right;
}

.price-wrap{
  margin-right: 100px;
  /*flex: 1;*/
}
.price{
  text-align: center;
  font-size: 3em;
  color: var(--main-color);
  font-weight: bold;

}
.price-title{
  font-weight: normal;
  font-size: 0.5em;
  margin-bottom: -10px;
}
.step{
  width: 100%;
}

</style>
<style scoped>
.date_w .date{
  position: relative;
  max-width: 160px;

}
.date_w .invalid-feedback{
  margin-top: 1em;

}
.invalid-feedback{
  display: block;
  max-width: 100%;
}

.note{
  display: block;
  max-width: 100%;
  font-size: 0.8em;
}

.m-5{
  margin: 1em;
}

.container.content{
  padding: 0 20px;
}

.cf {
  flex-flow: wrap;
  justify-content: space-between;
  width: 100%;
  min-height: 20px;
  display: flex;
}



</style>
<style>
.slc {
  width: 18.5%;
}
.slc_w.slc_wnw {
  flex-flow: row;
}
.slc_w.slc_wnw{
  flex-wrap: nowrap;
}
.col-14 {
  width: 24%;
}

/** RESPO */

@media screen and (max-width: 991px) {
  .con {
    justify-content: center;
  }

  .hero {
    padding-top: 140px;
  }

  .coh {
    width: 100%;
  }

  .h2 {
    font-size: 27px;
  }

  .h3 {
    font-size: 19px;
  }

  .footer {
    padding-top: 40px;
    padding-bottom: 40px;
  }

  .copy {
    text-align: left;
  }

  .mm {
    background-color: var(--midnight-blue);
    align-items: flex-start;
    width: 100%;
    height: 100vh;
    margin-right: -100%;
    padding: 110px 44px 44px;
    position: fixed;
    inset: 0% 0% auto auto;
  }

  .ham {
    margin-left: 17px;
    display: flex;
  }

  .container.c-rev {
    flex-wrap: wrap-reverse;
  }

  .container.container_pds {
    padding-left: 20px;
    padding-right: 20px;
  }

  .tl {
    border-width: 1px 0;
    border-top-style: solid;
    border-top-color: var(--medium-sea-green);
    border-bottom-style: solid;
    border-bottom-color: var(--medium-sea-green);
    width: 100%;
    height: auto;
    margin-bottom: -1px;
    padding: 17px;
  }

  .tl-w, .col-23 {
    width: 100%;
  }

  .col-13 {
    width: 64%;
    margin-bottom: 54px;
  }

  .f-co {
    width: 100%;
    margin-bottom: 20px;
  }

  .f-r {
    align-items: flex-start;
    width: 100%;
  }

  .f-l, .col-12 {
    width: 100%;
  }

  .col-12.mb-m {
    margin-bottom: 40px;
  }

  .rop.rop-x {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .btna {
    flex-direction: row;
    align-items: center;
    width: 100%;
    height: auto;
  }

  .col-34 {
    width: 100%;
  }

  .hero-ac {
    justify-content: flex-start;
    width: 100%;
    padding-top: 0;
    padding-bottom: 0;
    inset: auto auto 0% 0%;
  }

  .co-img {
    width: 60%;
    margin: 0 auto 20px 10%;
  }

  .co-col {
    width: 80%;
    margin-bottom: 40px;
  }

  .slc_w.slc_wnw {
    flex-flow: wrap;
  }

  .slc, .slc.slc_m {
    width: 22%;
  }

  .slc_info {
    width: 100%;
  }

  .mb {
    margin-bottom: 21px;
  }

  .tblk, .col-14 {
    width: 100%;
  }

  .hide_t {
    display: none;
  }

  .cf_bx.bg1 {
    width: 100%;
  }
}

@media screen and (max-width: 767px) {
  .sec {
    padding-top: 40px;
    padding-bottom: 20px;
  }

  .hero {
    padding-top: 70px;
  }

  .btn {
    padding: 14px 20px;
  }

  .btn.btn_xl {
    padding: 17px 20px;
  }

  .h2 {
    font-size: 24px;
  }

  .footer {
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .logo {
    width: 120px;
  }

  .mm, .container {
    padding-left: 20px;
    padding-right: 20px;
  }

  .h1 {
    font-size: 37px;
  }

  .ni-i {
    height: 190px;
  }

  .col-13 {
    width: 100%;
    margin-bottom: 0;
  }

  .cx{
    flex-wrap: wrap;
  }

  .f-co {
    width: 100%;
    margin-bottom: 10px;
  }

  .hh1 {
    font-size: 31px;
  }

  .hh2 {
    font-size: 21px;
  }

  .header-co {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .col-12.mb-m {
    margin-bottom: 20px;
  }

  .header-i {
    display: none;
  }

  .rop-t {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .rop-c {
    width: 100%;
    margin-bottom: 10px;
  }

  .co-img {
    margin-left: 5%;
  }

  .co-col {
    width: 90%;
  }

  .hero-w {
    padding: 10px;
  }

  .footer-w {
    padding-left: 10px;
    padding-right: 10px;
  }

  .chew {
    padding: 7px 14px;
    line-height: 1.2em;
  }

  .check {
    width: 32px;
    height: 32px;
  }

  .frm-co {
    padding-left: 20px;
    padding-right: 20px;
  }

  .col_hero_w {
    height: 280px;
  }

  .slc_w {
    grid-column-gap: .5em;
    grid-row-gap: .5em;
  }

  .slc {
    width: 31%;
    padding: 17px 4px 14px;
    font-size: 16px;
  }

  .slc_i {
    width: 30px;
    height: 30px;
    margin-bottom: 4px;
  }

  .px.mb {
    font-size: 18px;
    line-height: 1.4em;
  }

  .date_w {
    grid-column-gap: 20px;
    grid-row-gap: 20px;
    justify-content: space-around;
    width: 100%;
  }

  .mb {
    margin-bottom: 11px;
  }
}

@media screen and (max-width: 479px) {
  .h4 {
    font-size: 17px;
  }

  .hh1 {
    font-size: 25px;
  }

  .header-i {
    display: none;
  }

  .co-img {
    width: 80%;
    margin-left: 0%;
  }

  .co-col {
    width: 100%;
  }

  .slc, .slc.slc_m {
    width: 48%;
  }

  .date_w {
    flex-flow: wrap;
    padding: 14px;
  }

  .date_sep {
    width: 100%;
    height: 1px;
  }
  .vek_info{
    width: 100%;
    margin-left: 0;
  }
}

/*100% max*/
html, body, #app{
  width: 100%;
}
h2 .tooltip-container{
  margin-left: 3px;
  top: -2px
}
h2 + small{
  display: block;
  margin-bottom: .6em;
}

</style>
